import type { Repository, AuthenticationConfigurationResource, SettingsMetadataItemResource } from "@octopusdeploy/octopus-server-client";
import { SettingsIdValues } from "@octopusdeploy/octopus-server-client";

export async function getAuthenticationConfiguration(repository: Repository): Promise<{ authenticationConfiguration: AuthenticationConfigurationResource; authenticationMetaData: SettingsMetadataItemResource }> {
    const authenticationMetaData = await repository.Settings.getById(SettingsIdValues.Authentication);
    const authenticationConfiguration = await repository.Settings.getValues(authenticationMetaData);

    return { authenticationConfiguration, authenticationMetaData };
}
